// @lib-firebase-auth
import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "firebaseApp";

// Create a context for the authentication state
const AuthContext = createContext();

// Use this hook to access the auth context
export const useAuth = () => {
  return useContext(AuthContext);
};

// Define the AuthProvider
export const AuthProvider = ({ children, defaulPrivateProfile = {}, defaulPublicProfile = {} }) => {
  
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      //initializeProfile(user);
      setCurrentUser(user);
      setLoading(false);
    });
    // Cleanup subscription on unmount
    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};